import config from '@/config'
import { RoleInOffer } from '@/features/offers/constants'

// Procurement officers can only open these tabs on the offer page (see OfferTabList), so print is
// limited to the same content.
const PROCUREMENT_PRINTABLE_TABS = ['sourcing', 'gcpr', 'pr']
const PROCUREMENT_PRINTABLE_DOCS = ['SOURCING_ANNEX', 'SOURCING_INTERNAL_DOCUMENT', 'VENDOR_QUOTATION']

const isProcurementOfficer = (role) => role === RoleInOffer.PROCUREMENT_OFFICER

// The order here is the order of both the modal's checkbox list and the pages in the printed PDF.
export const getPrintTabOptions = ({ subSystemNames, role }) => {
  const subSystemTabs = subSystemNames.map((name, index) => ({
    value: `subSystem-${index}`,
    label: `Subsystem 1.${index + 1} ${name}`,
  }))
  const prTab = config.PREnabled ? [{ value: 'pr', label: 'PR' }] : []
  const handoverFormTab = config.handoverFormEnabled ? [{ value: 'handoverForm', label: 'Handover Form' }] : []

  const tabOptions = [
    { value: 'offerOverview', label: 'Offer Overview' },
    ...subSystemTabs,
    { value: 'legal', label: 'Legal' },
    { value: 'commercialChecklist', label: 'Commercial Checklist' },
    { value: 'booking', label: 'Booking' },
    {
      value: 'sourcing',
      label: 'Sourcing',
      children: [
        { value: 'sourcingGeneral', label: 'General' },
        { value: 'sourcingPM040', label: 'PM040' },
        { value: 'sourcingPM100', label: 'PM100' },
      ],
    },
    { value: 'gcMaterial', label: 'GC Material' },
    { value: 'gcpr', label: 'GCPR' },
    ...prTab,
    ...handoverFormTab,
    { value: 'costStructure', label: 'Cost Structure' },
    { value: 'history', label: 'History' },
  ]

  return isProcurementOfficer(role)
    ? tabOptions.filter((tab) => PROCUREMENT_PRINTABLE_TABS.includes(tab.value))
    : tabOptions
}

export const getSelectableTabValues = (tabOptions) =>
  tabOptions.flatMap((tab) =>
    Array.isArray(tab.children) && tab.children.length > 0 ? tab.children.map((child) => child.value) : [tab.value]
  )

export const filterPrintDocOptions = (docOptions, role) =>
  isProcurementOfficer(role) ? docOptions.filter((doc) => PROCUREMENT_PRINTABLE_DOCS.includes(doc.value)) : docOptions
